import React from 'react';
import ReactDiffViewer from 'react-diff-viewer-continued';
import SpinnerChidori from 'components/SpinnerChidori/SpinnerChidori';
import { DetailedSparkJobDTO } from 'types/types';
import '../JobPropertiesModal.scss';

type JobPropertiesContentProps = {
  job: DetailedSparkJobDTO | undefined;
  isLoading: boolean;
  height?: string;
};

export const JobPropertiesContent: React.FC<JobPropertiesContentProps> = ({
  job,
  isLoading,
  height,
}) => {
  if (isLoading) return <SpinnerChidori />;

  return (
    <div className="job-props__body" style={{ maxHeight: `${height}` }}>
      <ReactDiffViewer
        newValue={job?.properties ?? ''}
        splitView={true}
        useDarkTheme={false}
        showDiffOnly={false}
        disableWordDiff={true}
      />
    </div>
  );
};

export default JobPropertiesContent;
